import { render, staticRenderFns } from "./TrentinoRegenerationSidebar.vue?vue&type=template&id=0b9a7fa9"
import script from "./TrentinoRegenerationSidebar.vue?vue&type=script&lang=js"
export * from "./TrentinoRegenerationSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports